// import React, { useState, useEffect } from 'react';
// import '../styles/style.css';
// import api from '../api/axios';
// import 'bootstrap/dist/css/bootstrap.min.css';

// const Carousel = () => {
//   const [slides, setSlides] = useState([]);
//   const [activeIndex, setActiveIndex] = useState(0);

//   useEffect(() => {
//     api.get('companyblog/sliders/')
//       .then(res => setSlides(res.data))
//       .catch(err => console.error("Slider fetch error:", err));
//   }, []);

//   useEffect(() => {
//     if (!slides.length) return;

//     const timer = setInterval(() => {
//       setActiveIndex(prev =>
//         prev === slides.length - 1 ? 0 : prev + 1
//       );
//     }, 5000);

//     return () => clearInterval(timer);
//   }, [slides]);

//   const goToSlide = (index) => {
//     setActiveIndex(index);
//   };

//   return (
//     <div className="carousel-container">
//       <div className="carousel carousel-dark slide vh-100">

//         {/* Indicators */}
//         <div className="carousel-indicators">
//           {slides.map((_, index) => (
//             <button
//               key={index}
//               className={index === activeIndex ? "active" : ""}
//               onClick={() => goToSlide(index)}
//             />
//           ))}
//         </div>

//         {/* Slides */}
//         <div className="carousel-inner vh-100">
//           {slides.map((slide, index) => (
//             <div
//               key={slide.id}
//               className={`carousel-item ${index === activeIndex ? "active" : ""}`}
//             >
//               <div className="slide-image-container vh-100">

//                 {slide.type === "image" && (
//                   <img
//                     src={slide.image}
//                     className="d-block w-100 vh-100"
//                     alt={slide.title}
//                   />
//                 )}

//                 {slide.type === "video" && (
//                   <video className="w-100 vh-100" autoPlay muted loop>
//                     <source src={slide.video} type="video/mp4" />
//                   </video>
//                 )}

//                 <div className="image-overlay"></div>
//               </div>

//               <div className="carousel-caption d-none d-md-block">
//                 <h5>{slide.title}</h5>
//                 <p>{slide.sub_title}</p>
//               </div>
//             </div>
//           ))}
//         </div>

//       </div>
//     </div>
//   );
// };

// export default Carousel;
import React, { useState, useEffect } from 'react';
import '../styles/style.css';
import api from '../api/axios';
import 'bootstrap/dist/css/bootstrap.min.css';

const Header = () => {
  const [slides, setSlides] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    api.get('companyblog/sliders/')
      .then(res => setSlides(res.data))
      .catch(err => console.error("Slider fetch error:", err));
  }, []);

  useEffect(() => {
    if (!slides.length) return;

    const timer = setInterval(() => {
      setActiveIndex(prev =>
        prev === slides.length - 1 ? 0 : prev + 1
      );
    }, 5000);

    return () => clearInterval(timer);
  }, [slides]);

  const goToSlide = (index) => {
    setActiveIndex(index);
  };

  return (
    <>
    <style>{`
  /* ===== CORE HEIGHT FIX ===== */
  .carousel-responsive {
    height: 100vh;
    width: auto;
  }

  .carousel-inner,
  .carousel-item {
    height: 100%;
  }

  .slide-image-container {
    position: relative;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  .slide-image-container img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  /* Overlay */
  .image-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.40);
    z-index: 1;
  }

  /* Caption */
  .carousel-caption-responsive {
    z-index: 2;
    bottom: 5%;
    text-align: center;
  }

  .carousel-caption-responsive h5 {
    font-size: 2rem;
    font-weight: 600;
  }

  .carousel-caption-responsive p {
    font-size: 1.1rem;
    color: #f8f8f8;
  }

  /* Indicators */
  .carousel-indicators button {
    width: 20px;
    height: 6px;
    border-radius: 10%;
    background: #7c7c7c;
    margin: 2px;
     border-color: none;
  }
  .carousel-indicators button.active {
  background: #1389e9; 
  }

  /* ===== TABLET & MOBILE ===== */
  @media (max-width: 768px) {
    .carousel-responsive {
      height: 70vh;
      width: auto;
    }

    .carousel-caption-responsive {
      bottom: 12%;
      padding: 0 1rem;
    }

    .carousel-caption-responsive h5 {
      font-size: 1.3rem;
    }

    .carousel-caption-responsive p {
      font-size: 0.95rem;
    }
       .slide-image-container {
    position: relative;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  }

  /* ===== SMALL PHONES ===== */
  @media (max-width: 480px) {
    .carousel-responsive {
      height: 60vh;
      width: auto;
    }
    .carousel-inner,
    .carousel-item {
      height: 100%;
    }
    .slide-image-container {
    position: relative;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
    .carousel-caption-responsive h5 {
      display:none;
    }

    .carousel-caption-responsive p {
      display: none;
    }
  
  }
`}</style>
    <div className="carousel-container">
      <div className="carousel carousel-dark slide carousel-responsive">

        {/* Indicators */}
        <div className="carousel-indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              className={index === activeIndex ? "active" : ""}
              onClick={() => goToSlide(index)}
              aria-label={`Slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Slides */}
        <div className="carousel-inner h-100">
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`carousel-item ${index === activeIndex ? "active" : ""}`}
            >
              <div className="slide-image-container">

                {slide.type === "image" && (
                  <img
                    src={slide.image}
                    className="d-block w-100 h-100 object-fit-cover"
                    alt={slide.title}
                  />
                )}

                {slide.type === "video" && (
                  <video
                    className="w-100 h-100 object-fit-cover"
                    autoPlay={window.innerWidth > 768}
                    muted
                    loop
                    playsInline
                  >
                    <source src={slide.video} type="video/mp4" />
                  </video>
                )}

                <div className="image-overlay"></div>
              </div>

              {/* Caption */}
              <div className="carousel-caption carousel-caption-responsive">
                <h5>{slide.title}</h5>
                <p>{slide.sub_title}</p>
              </div>

            </div>
          ))}
        </div>

      </div>
    </div>
    </>
  );
};


export default Header;
